import React, { Component } from 'react';
import { Table, Button, DatePicker, Row, Col, Select } from 'antd';
import {Parse} from 'parse';
import {Redirect, Link} from 'react-router-dom';
import moment from 'moment';

import { FormattedMessage } from 'react-intl';

import '../../styles/Mypage.css'

class PayoutList extends Component{

  constructor(props){
    super(props);
    this.state={
      payoutRequestList:[],
      payoutCompletedList:[],
      selectedRowKeys:[],
      numberOfKoreaPayout:0,
      numberOfPaypalPayout:0,
      numberOfVietnam: 0,
      selectedYear: '',
      selectedMonth: '',
      payoutstatus: false,
      showStatus: 'all',
      showMode:'completed'
    }
  }

  componentDidMount(){
     findPayout(true, undefined, this);
     findPayout(false, undefined, this);
     numberOfLastMonthPayout(undefined, 'all', this);
  }

  render(){
    if (!(Parse.User.current()&& Parse.User.current().id==='d8UCBviqoy')) {//payout_manager 의 objectId로 바꾸기
      return <Redirect to={{pathname: '/'}}/>;
    }//payout_manager 가 아닐경우 home으로 redirect

    const { MonthPicker } = DatePicker
    const { Option } = Select;

    const hasSelected = this.state.selectedRowKeys.length > 0; //payout completed btn 활성화 체크
    const rowSelection = {
      selectedRowKeys:this.state.selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const requestColumns = [{
        title: '이메일',
        dataIndex: 'userInfo.email',
        fixed:true,
        width:200
      },{
        title: '요청금액($)',
        dataIndex: 'userInfo.paymentRequest',
        fixed:true,
        width:60
      },{
      title: 'user정보',
      children:[
      {
        title: '이름',
        dataIndex:'userInfo.name',
      },
      {
        title: '은행',
        dataIndex: 'userInfo.accountBank',
      },
      {
        title: '예금주',
        dataIndex: 'userInfo.accountName',
      },
      {
        title: '우편번호',
        dataIndex: 'userInfo.zoneCode',
      },
      {
        title: '주소',
        dataIndex: 'userInfo.address',
      }
    ]},{
      title: '요청 방법',
      dataIndex: 'payoutMethod',
      filters: [{
          text: 'korea',
          value: 'korea',
        },{
          text: 'vietnam',
          value: 'vietnam',
        },{
          text: 'paypal',
          value: 'paypal',
      }],
      onFilter: (value, record) => record.payoutMethod.indexOf(value) === 0,
      width:80,
      fixed:'right'
    }];
    const completedColumns = [{
      title:'이메일',
      dataIndex:'userInfo.email'
    },{
      title:'요청금액 ($)',
      dataIndex:'userInfo.paymentRequest'
    },{
      title:'요청날짜',
      dataIndex:'createdAt'
    },{
      title:'송금 완료 날짜',
      dataIndex:'updatedAt'
    },{
      title: '요청 방법',
      dataIndex: 'payoutMethod',
      filters: [{
          text: 'korea',
          value: 'korea',
        },{
          text: 'vietnam',
          value: 'vietnam',
        },{
          text: 'paypal',
          value: 'paypal',
        }],
      onFilter: (value, record) => record.payoutMethod.indexOf(value) === 0,
      width:100,
      fixed:'right'
    }];
    return(
      <div>
        <p className="payouts-headline">
          <FormattedMessage
            id={'Payouts.headline'}
            defaultMessage={'PayoutList'}
          />
          <Button onClick={()=>this.setState({showMode:'requested'})}>
           정산 완료 리스트 보기  
          </Button>
          <Button onClick={()=>this.setState({showMode:'completed'})}>
                 송금신청 리스트 보기
          </Button>
        </p>
        <div>
        {
          this.state.showMode === 'completed' ? (
            <>
              <h1>
                {this.state.selectedYear}년 {this.state.selectedMonth}월의 정산 요청
                확인{' '}
              </h1>

              <Row>
                <Col span={4}>
                  <MonthPicker
                    onChange={this.setSelectedMonth.bind(this)}
                    allowClear={false}
                    disabledDate={this.setRangeDate}
                    placeholder="month"
                  />
                </Col>
                <Col span={100}>
                  <Select
                    defaultValue={this.state.showStatus}
                    dropdownMatchSelectWidth={false}
                    onChange={this.checkPayoutStatus.bind(this)}
                  >
                    <Option value="true">송금완료</Option>
                    <Option value="false">미송금</Option>
                    <Option value="all">전체</Option>
                  </Select>
                </Col>
                <Col>
                  <Button onClick={this.applyDateToTable.bind(this)}>날짜 필터 적용</Button> 
                  <></>
                  <Button onClick={this.resetPayoutRequestTable.bind(this)}>초기화</Button>
                </Col>
              </Row>
              <h2>
                Korea {this.state.numberOfKoreaPayout}명&nbsp; Paypal{' '}
                {this.state.numberOfPaypalPayout}명&nbsp; Vietnam{' '}
                {this.state.numberOfVietnam}명
              </h2>
              <p>payout request</p>
              <Table
                rowSelection={rowSelection}
                columns={requestColumns}
                dataSource={this.state.payoutRequestList}
                bordered
                locale={{
                  filterConfirm: 'OK',
                  filterReset: 'Reset',
                  emptyText: 'No Data',
                }}
                pagination={{ showSizeChanger: true }}
                scroll={{ x: '130%', y: '700px' }}
              />

              <div style={{ marginBottom: 16 }}>
                <Button
                  type="primary"
                  onClick={async () => {
                    await this.payoutCompleted(rowSelection)
                    await this.setState({ selectedRowKeys: [] })
                  }}
                  disabled={!hasSelected}
                >
                  payout completed
                </Button>
              </div>
            </>
          ) : (
            <>
              <p>Payout Completed</p>
              <Table
                columns={completedColumns}
                dataSource={this.state.payoutCompletedList}
                bordered
                locale={{
                  filterConfirm: 'OK',
                  filterReset: 'Reset',
                  emptyText: 'No Data',
                }}
                pagination={{ showSizeChanger: true }}
                scroll={{ x: '100%', y: '700px' }}
              />
            </>
          )
        }

        </div>
   
      </div>
    );
  }//render end

  onSelectChange = (selectedRowKeys) => {
      console.log('selectedRowKeys changed: ', selectedRowKeys);//payout class 의 objectId
      this.setState({ selectedRowKeys });
    }
  payoutCompleted = async(payoutRequestId) => {
    //payoutStatus를 true로 바꾸고
    //userInfo 정보 지우기 ==> 이메일이랑 요청 크레딧은 남길까? 아니면 money class통해서 보여줄까?
    const payoutQuery = new Parse.Query(Parse.Object.extend('Payout'));

    for(var i in payoutRequestId.selectedRowKeys){
      const payoutObjectId=payoutRequestId.selectedRowKeys[i];
      try {
        const payout = await payoutQuery.get(payoutObjectId);
        payout.set('payoutStatus',true);
        payout.set('userInfo',{email:payout.get('userInfo').email, paymentRequest:payout.get('userInfo').paymentRequest});
        await payout.save();
      } catch (err) {
        console.log(err);
      }
    }
    await findPayout(true, undefined, this);
    await findPayout(false, undefined, this);

  }

  setRangeDate = (current) => {
    return current < moment('20210101') || current > moment().add(1, 'M');
  }

  setSelectedMonth(date){
    if(date === null) return;
    const dateString= date.format('YYYYMM');
    numberOfLastMonthPayout(dateString, this.state.showStatus, this);
  }

  checkPayoutStatus(value){
    this.setState({showStatus: value});
    numberOfLastMonthPayout(this.state.selectedYear+this.state.selectedMonth, value, this);
  }

  applyDateToTable () {
    findPayout(false, this.state.selectedYear+this.state.selectedMonth, this);
  }

  resetPayoutRequestTable () {
    findPayout(false, undefined, this);
  }

}

function setDateInfo(dateString) {
  //오늘날짜
  const dateMoment = dateString ? moment(dateString) : moment()

  const dateMonth = dateMoment.format('MM');
  const dateYear = dateMoment.format('YYYY');

  const beforeOneMonth = dateMoment.subtract(1,'M').format('MM')
  const beforeOneYear = dateMoment.format('YYYY');

  return {
    dateMonth: dateMonth,
    dateYear: dateYear,
    beforeOneMonth: beforeOneMonth,
    beforeOneYear: beforeOneYear
  }
}

//payoutList end
function findPayout(payoutStatus, dateString, self){

  const payoutQuery = new Parse.Query(Parse.Object.extend('Payout'));
  let payoutListArray=[];
  payoutQuery.equalTo('payoutStatus', payoutStatus );

  //date 정보가 존재할 경우 payoutList에 filter을 걸어준다.
  if(dateString) {
    const dateInfo = setDateInfo(dateString);
    payoutQuery.greaterThanOrEqualTo('createdAt',`${dateInfo.beforeOneYear}${dateInfo.beforeOneMonth}15`)
    payoutQuery.lessThan('createdAt',`${dateInfo.dateYear}${dateInfo.dateMonth}15`)
  }

  payoutQuery.descending("updatedAt"); //최근 수정한 것부터 불러오기
  payoutQuery.limit(700);
  payoutQuery.find().then((result)=>{
  payoutListArray = result.map((list,index)=>{
      const newObj={
        key:list.id,
        userInfo:list.get('userInfo'),
        payoutStatus:list.get('payoutStatus'),
        payoutMethod:list.get('payoutMethod'),
        userId:list.get('user').id,
        moneyId:list.get('moneyId').id,
        receipt:list.get('receipt'),
        createdAt : moment(list.createdAt).format('YYYY.MM.DD HH:mm:ss'),
        updatedAt: moment(list.updatedAt).format('YYYY.MM.DD HH:mm:ss'),
      }
      return newObj;
    });
    if(payoutStatus===false)
     self.setState({payoutRequestList : payoutListArray });
   else{
     self.setState({payoutCompletedList :  payoutListArray});
   }
  }).catch((error)=>{console.log(error);})

}

//지난 달의 Payout 숫자를 표시
function numberOfLastMonthPayout(dateString, payoutStatus, self){

  const dateInfo =  setDateInfo(dateString);
  
  const payoutQuery = new Parse.Query(Parse.Object.extend("Payout"))
  .greaterThanOrEqualTo('createdAt',`${dateInfo.beforeOneYear}${dateInfo.beforeOneMonth}15`)
  .lessThan('createdAt',`${dateInfo.dateYear}${dateInfo.dateMonth}15`)
  
  //모든 상태가 아니면 호출
  if(payoutStatus !== 'all'){
    payoutQuery.equalTo('payoutStatus',payoutStatus)
  }

  payoutQuery.limit(Number.MAX_SAFE_INTEGER)
  .find().then((result)=>{

    let payoutKorea = 0;
    let payoutPaypal = 0;
    let payoutVietnam = 0;

    result.forEach(data => {
      switch(data.get('payoutMethod')){
        case 'korea':
          payoutKorea++;
          break;
        case 'paypal':
          payoutPaypal++;
          break;
        case 'vietnam':
          payoutVietnam++;
          break;

        default:  
          // break;
      }
    })

    self.setState({
      numberOfKoreaPayout: payoutKorea,
      numberOfPaypalPayout: payoutPaypal,
      numberOfVietnam: payoutVietnam,
      selectedYear: dateInfo.dateYear,
      selectedMonth: dateInfo.dateMonth,
    });

  });
}
export default PayoutList;
